import {Injectable, InjectionToken} from '@angular/core';
import {MODE} from '../models';
import {Translates} from "../services/router/interfaces/translate";

@Injectable()
export class AppConfig {
  /* Режим работы ангуляра */
  mode = MODE.MODE_ROUTER;
  /* Роут до API авиа */
  searchAviaUrl: string;
  /* Валюта */
  currencySigns: string;
  /* apiKey */
  apiKey: string;
  /* Текста для прогресбара авиа */
  aviaProgressBarTexts: string[];
  translates: Translates;
  platform: string;
  brand: string;
  brandHost: string;
  isPreview: boolean;

  constructor() {
    const params = (window as any).angularParams;

    this.mode = params.mode;
    this.searchAviaUrl = params.searchAviaUrl;
    this.currencySigns = params.currencySigns;
    this.apiKey = params.apiKey;
    this.aviaProgressBarTexts = params.aviaProgressBarTexts;
    this.translates = params.translates;
    this.platform = params.platform;
    this.brand = params.brand;
    this.brandHost = params.brandHost;
    this.isPreview = Boolean(params.isPreview);
  }
}

export const APP_CONFIG = new InjectionToken<AppConfig>('APP_CONFIG');
